import React, { useMemo, useState } from "react";
import styles from "./MainLayout.module.scss";
import { Link, Outlet, useLocation, useNavigate } from "react-router-dom";
import Sidebar from "../components/sidebar/Sidebar";
import search from "../assets/images/icons/search.svg";
import search_dark from "../assets/images/icons/search_dark.svg";
import message_dark from "../assets/images/icons/message_dark.svg";
import notification from "../assets/images/icons/notification.svg";
import user from "../assets/images/icons/user.svg";
import menuIcon from "../assets/images/icons/menu.svg";
import { useTranslation } from "react-i18next";

const MainLayout = () => {
  const location = useLocation();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const navigate = useNavigate();
  const { t } = useTranslation("translation");

  const pageTitle = useMemo(() => {
    if (location.pathname === "/dashboard") return t("overview");
    if (location.pathname.includes("/dashboard/products/create-variants"))
      return t("add_variants");
    if (location.pathname.includes("/dashboard/products/create-variant-images"))
      return t("add_images");
    if (location.pathname.includes("/dashboard/products/edit-variants"))
      return t("edit_variants");
    if (location.pathname.includes("/dashboard/products/edit-variant-images"))
      return t("edit_images");
    if (location.pathname.includes("/dashboard/products/edit"))
      return t("edit_product");
    if (location.pathname.includes("/dashboard/products/create"))
      return t("create_product");
    if (location.pathname.startsWith("/dashboard/products"))
      return t("products");
    if (location.pathname.startsWith("/dashboard/orders")) return t("orders");
    if (location.pathname.startsWith("/dashboard/messages"))
      return t("messages");
    if (location.pathname.startsWith("/dashboard/settings"))
      return t("settings.title");
    if (location.pathname.startsWith("/dashboard/info")) return t("store_info");
    if (location.pathname.startsWith("/dashboard/delivery"))
      return t("delivery");
    return t("dashboard");
  }, [location.pathname, t]);

  return (
    <div className={styles.layout}>
      <Sidebar
        open={sidebarOpen}
        setOpen={setSidebarOpen}
        collapsed={sidebarCollapsed}
        setCollapsed={setSidebarCollapsed}
      />

      <header
        className={`${styles.header} ${
          sidebarCollapsed ? styles.collapsed : ""
        }`}
      >
        <div className={styles.left}>
          <button
            className={styles.menuBtn}
            onClick={() => setSidebarOpen(true)}
          >
            <img src={menuIcon} alt="menu" />
          </button>
          <p className={styles.page_title}>{pageTitle}</p>
        </div>
        <div className={styles.actions}>
          <div className={styles.input_wrapper}>
            <img src={search} alt="" />
            <input
              type="text"
              name=""
              id=""
              placeholder={t("search_here") || ""}
            />
          </div>
          <div
            onClick={() => navigate("messages")}
            className={`${styles.icon} ${styles.message_icon}`}
          >
            <img src={message_dark} alt="" />
          </div>
          <div className={`${styles.icon} ${styles.search_icon}`}>
            <img src={search_dark} alt="" />
          </div>
          <div
            onClick={() => navigate("notifications")}
            className={styles.icon}
          >
            <img src={notification} alt="" />
          </div>
          <div className={styles.line} />
          <Link to="/dashboard/info" className={styles.user}>
            <img src={user} alt="" />
          </Link>
        </div>
      </header>
      <div
        className={`${styles.outlet} ${
          sidebarCollapsed ? styles.collapsed : ""
        }`}
      >
        <Outlet />
      </div>
    </div>
  );
};

export default MainLayout;
